/**
 * Review step for F1 hybrid cross setup before Cultivera writes occur
 */

import React, { useState } from 'react';
import type { Plant } from '../types/breeding';

interface HybridReviewProps {
  seedParent: Plant;
  pollenDonor: Plant;
  generatedName: string;
  finalName: string;
  seedCount: number;
  roomName: string;
  onConfirm: (strainName: string) => void;
  onStartOver: () => void;
}

export function HybridReview({
  seedParent,
  pollenDonor,
  generatedName,
  finalName,
  seedCount,
  roomName,
  onConfirm,
  onStartOver,
}: HybridReviewProps) {
  const [strainName, setStrainName] = useState(finalName);

  return (
    <div className="summary-section">
      <div className="hybrid-review-card">
        <div className="review-header">
          <div>
            <h2>Review F1 Cross</h2>
            <p>Confirm parentage and strain naming before creating seed inventory.</p>
          </div>
          <span className="badge badge-f1">F1</span>
        </div>

        <div className="parent-grid">
          <div className="parent-panel">
            <span className="panel-label">Seed Parent</span>
            <h3>{seedParent.StrainName}</h3>
            <p>{seedParent.TSID}</p>
            <p>{seedParent.RoomName}</p>
          </div>

          <div className="parent-panel">
            <span className="panel-label">Pollen Donor</span>
            <h3>{pollenDonor.StrainName}</h3>
            <p>{pollenDonor.TSID}</p>
            <p>{pollenDonor.RoomName}</p>
          </div>
        </div>

        <div className="form-group strain-review-group">
          <label htmlFor="confirmedF1Name">F1 Strain Name:</label>
          <input
            type="text"
            id="confirmedF1Name"
            value={strainName}
            onChange={(event) => setStrainName(event.target.value)}
          />
          <span className="hint">Generated: {generatedName}</span>
        </div>

        <div className="review-detail-row">
          <div>
            <span className="panel-label">Seeds</span>
            <strong>{seedCount.toLocaleString()}</strong>
          </div>
          <div>
            <span className="panel-label">Destination</span>
            <strong>{roomName}</strong>
          </div>
        </div>

        <div className="review-actions">
          <button className="btn-secondary" onClick={onStartOver}>
            Back
          </button>
          <button className="btn-primary" onClick={() => onConfirm(strainName)}>
            Create F1 Seeds
          </button>
        </div>
      </div>
    </div>
  );
}
